// PLP mobile bottom bar: Filteren (n) · Sorteren, both opening Dawn's one mobile facets drawer

// counted off the URL, not off [data-cm-active-count]: that node only counts the sidebar's own groups, never the pills
function activeCount() {
  var params = new URLSearchParams(window.location.search);
  var count = 0;
  var priceCounted = false;
  params.forEach(function (value, key) {
    if (key.indexOf('filter.') !== 0 || value === '') return;
    // gte + lte are one "Prijs" chip, the same way the active-filter row renders them
    if (key.indexOf('filter.v.price.') === 0) {
      if (priceCounted) return;
      priceCounted = true;
    }
    count += 1;
  });
  return count;
}

function initCmPlpMobileBar() {
  var opener = document.querySelector('summary.mobile-facets__open-wrapper');
  var grid = document.getElementById('ProductGridContainer');
  var openLabel = opener ? opener.querySelector('.mobile-facets__open') : null;
  var details = opener ? opener.closest('details') : null;
  if (!opener || !grid || !openLabel || !details || !('IntersectionObserver' in window)) return;

  var mq = window.matchMedia('(max-width: 749px)');
  var openerAbove = false;
  var gridVisible = false;

  var bar = document.createElement('div');
  bar.className = 'cm-plp-bar';
  bar.hidden = true;

  var filterButton = document.createElement('button');
  filterButton.type = 'button';
  filterButton.className = 'cm-plp-bar__btn';
  var filterText = document.createElement('span');
  var badge = document.createElement('span');
  badge.className = 'cm-plp-bar__badge';
  filterButton.appendChild(filterText);
  filterButton.appendChild(badge);

  var sortLabel = window.cmPlpStrings ? window.cmPlpStrings.sort : '';
  bar.appendChild(filterButton);
  // no sort control without its localized label; an empty second button would just eat half the bar
  if (sortLabel) {
    var sortButton = document.createElement('button');
    sortButton.type = 'button';
    sortButton.className = 'cm-plp-bar__btn';
    sortButton.textContent = sortLabel;
    sortButton.addEventListener('click', function () {
      bar.hidden = true;
      opener.click();
      var sort = document.getElementById('SortBy-mobile');
      if (sort) sort.focus();
    });
    bar.appendChild(sortButton);
  }
  document.body.appendChild(bar);

  function syncLabels() {
    filterText.textContent = window.cmPlpStrings ? window.cmPlpStrings.filter : '';
    var n = activeCount();
    badge.textContent = n > 0 ? String(n) : '';
    badge.hidden = n === 0;
  }

  function updateVisibility() {
    bar.hidden = !(mq.matches && openerAbove && gridVisible && !details.open);
  }

  new IntersectionObserver(
    function (entries) {
      var entry = entries[0];
      openerAbove = !entry.isIntersecting && entry.boundingClientRect.top < 0;
      updateVisibility();
    },
    { threshold: 0 }
  ).observe(opener);

  new IntersectionObserver(
    function (entries) {
      gridVisible = entries[0].isIntersecting;
      updateVisibility();
    },
    { threshold: 0 }
  ).observe(grid);

  // facets.js pushes the new URL, then replaces .mobile-facets__open — so the swap is the cue to re-read it
  new MutationObserver(syncLabels).observe(openLabel, { childList: true, characterData: true, subtree: true });
  window.addEventListener('popstate', syncLabels);

  filterButton.addEventListener('click', function () {
    bar.hidden = true;
    opener.click();
  });
  details.addEventListener('toggle', updateVisibility);
  mq.addEventListener('change', updateVisibility);
  syncLabels();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initCmPlpMobileBar);
} else {
  initCmPlpMobileBar();
}
